import { useEffect, useState} from "react";
import {
  Button,
  Form,
} from "react-bootstrap";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
    ClearAdminResponce,
    EditReportingCradicialsAction,
    GetReportingCradicialsAction,
  } from "../../../Redux/Actions/AdminActions";

  import { IReduxState } from "../../../utils/types";


const ReportingTab = () => {
    const adminState = useSelector((state: IReduxState) => state.Admin);
    const [craditials, setCraditials] = useState<any>({});
    const [isEditCradicial, setIsEditCradicial] = useState(false);
    const dispatch = useDispatch()
    
    const reportingFormik = useFormik({
        initialValues: {
          Google_account_ids: "",
          facebook_tokens: "",
          facebook_account_ids: "",
        },
        onSubmit: (value, { resetForm }) => {
          dispatch(
            EditReportingCradicialsAction({
              ...craditials,
              Google_account_ids: value.Google_account_ids,
              facebook_tokens: value.facebook_tokens,
              facebook_account_ids: value.facebook_account_ids,
            })
          );
        },
      });
    
    useEffect(() => {
        if (adminState?.success) {
          setIsEditCradicial(false);
          dispatch(GetReportingCradicialsAction());
        }
    
        return () => {
          dispatch(ClearAdminResponce());
        };
      }, [adminState?.success, dispatch]);

      useEffect(() => {
        if (adminState?.craditials) {
          setCraditials(adminState?.craditials);
          dispatch(GetReportingCradicialsAction());
        }
      }, [adminState?.craditials, dispatch]);
    

    return (
        <>
        <div>
                <div className="report-credential-section">
                  <div className="google-table">
                    <div className="account-id">
                      <p>Google Account IDs</p>
                      {isEditCradicial ? (
                        <Form.Control
                          name="Google_account_ids"
                          defaultValue={
                            reportingFormik.values.Google_account_ids
                          }
                          onChange={reportingFormik.handleChange}
                          onBlur={reportingFormik.handleBlur}
                          as={"textarea"}
                        />
                      ) : (
                        <div className="account-id-data">
                          <span>{craditials?.Google_account_ids}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="facebook-table">
                    <div className="account-id">
                      <p>Facebook Account IDs</p>
                      {isEditCradicial ? (
                        <Form.Control
                          name="facebook_account_ids"
                          defaultValue={
                            reportingFormik.values.facebook_account_ids
                          }
                          onChange={reportingFormik.handleChange}
                          onBlur={reportingFormik.handleBlur}
                          as={"textarea"}
                        />
                      ) : (
                        <div className="account-id-data">
                          <span>{craditials?.facebook_account_ids}</span>
                        </div>
                      )}
                    </div>

                    <div className="account-id">
                      <p>Facebook Token</p>
                      {isEditCradicial ? (
                        <Form.Control
                          name="facebook_tokens"
                          defaultValue={reportingFormik.values.facebook_tokens}
                          onChange={reportingFormik.handleChange}
                          onBlur={reportingFormik.handleBlur}
                          as={"textarea"}
                        />
                      ) : (
                        <div className="account-id-data">
                          <span>{craditials?.facebook_tokens}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className={"craditials craditials-box"}>
                  <Button
                    disabled={isEditCradicial}
                    variant="dark"
                    onClick={() => {
                      setIsEditCradicial(true);
                      reportingFormik.setValues({
                        Google_account_ids: craditials?.Google_account_ids,
                        facebook_tokens: craditials?.facebook_tokens,
                        facebook_account_ids: craditials?.facebook_account_ids,
                      });
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    disabled={!isEditCradicial}
                    variant="dark"
                    onClick={() => reportingFormik.handleSubmit()}
                  >
                    Save
                  </Button>
                </div>
              </div>
        </>
    )
}
export default ReportingTab